module.exports = __webpack_public_path__ + "0fc2bb58ad9a8e9a56eba58b0c331f88.pdf";